<template>
  <HeaderForm :left-span="(selectItem.taskType==='PERSON_IMPORT'||selectItem.taskType==='BANK_CARD_IMPORT'||selectItem.taskType==='VERIFY_DEVICE_PULL_PERSON')?24:16">
    <template v-slot:prepend>
      <el-form
        ref="form"
        :inline="true"
        :model="value"
      >
        <el-form-item
          v-if="selectItem.taskType==='PERSON_IMPORT_HEADER'"
          prop="photoName"
        >
          <el-input
            v-model="value.photoName"
            clearable
            placeholder="照片名称"
          />
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType!=='PERSON_IMPORT_HEADER'&&selectItem.taskType !=='WHITELIST_IMPORT'||selectItem.taskType==='VERIFY_DEVICE_PULL_PERSON'"
          prop="personName"
        >
          <el-input
            v-model="value.personName"
            clearable
            placeholder="姓名"
          />
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType ==='WHITELIST_IMPORT'"
          prop="licensePlate"
        >
          <el-input
            v-model="value.licensePlate"
            clearable
            placeholder="车牌号"
          />
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType!=='PERSON_IMPORT_HEADER'&&selectItem.taskType !=='WHITELIST_IMPORT'&&selectItem.taskType!=='VERIFY_DEVICE_PULL_PERSON'"
          prop="idcardNumber"
        >
          <el-input
            v-model="value.idcardNumber"
            clearable
            placeholder="身份证号码"
          />
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType==='VERIFY_DEVICE_PULL_PERSON'"
          prop="devicePersonCode"
        >
          <el-input
            v-model="value.devicePersonCode"
            clearable
            placeholder="设备人员编码"
          />
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType==='VERIFY_DEVICE_PULL_PERSON'"
          prop="personType"
        >
          <el-select
            v-model="value.personType"
            clearable
            placeholder="人员类型"
          >
            <el-option
              label="全部"
              :value="null"
            />
            <el-option
              v-for="item in personType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />

          </el-select>
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType==='PERSON_IMPORT'"
          prop="teamName"
        >
          <el-input
            v-model="value.teamName"
            clearable
            placeholder="班组"
          />
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType==='PERSON_IMPORT'"
          prop="workerTypeName"
        >
          <el-input
            v-model="value.workerTypeName"
            clearable
            placeholder="工种"
          />
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType==='PERSON_IMPORT'"
          prop="jobNumber"
        >
          <el-input
            v-model="value.jobNumber"
            clearable
            placeholder="工号"
          />
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType==='PERSON_IMPORT'||selectItem.taskType==='VERIFY_DEVICE_PULL_PERSON'"
          prop="personPhotoStatus"
        >
          <el-select
            v-model="value.personPhotoStatus"
            clearable
            placeholder="照片"
          >
            <el-option
              label="全部"
              :value="null"
            />
            <el-option
              label="已采集"
              :value="1"
            />
            <el-option
              label="未采集"
              :value="0"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType==='PERSON_IMPORT'||
            selectItem.taskType==='PERSON_IMPORT_HEADER'||
            selectItem.taskType==='BLACKLIST_IMPORT'||
            selectItem.taskType==='VERIFY_DEVICE_PULL_PERSON'
          "
          prop="recordStatus"
        >
          <el-select
            v-model="value.recordStatus"
            clearable
            placeholder="请选择状态"
          >
            <el-option
              label="全部"
              :value="null"
            />
            <el-option
              label="成功"
              :value="1"
            />
            <el-option
              label="失败"
              :value="0"
            />
          </el-select>
        </el-form-item>
        <template v-if="selectItem.taskType==='BANK_CARD_IMPORT'">
          <el-form-item prop="bankName">
            <DictionarySelect
              v-model="value.bankName"
              placeholder="选择银行"
              dictionary-type-code="yhdm"
              @change="change"
            />
          </el-form-item>
          <el-form-item prop="cardNumber">
            <el-input
              v-model="value.cardNumber"
              clearable
              placeholder="银行卡号"
            />
          </el-form-item>
          <el-form-item prop="bankDeposit">
            <el-input
              v-model="value.bankDeposit"
              clearable
              placeholder="开户行"
            />
          </el-form-item>
        </template>
        <el-form-item
          v-if="selectItem.taskType==='PERSON_IMPORT' ||
            selectItem.taskType==='PERSON_IMPORT_HEADER'||
            selectItem.taskType==='BANK_CARD_IMPORT'||
            selectItem.taskType==='BLACKLIST_IMPORT'||
            selectItem.taskType==='WHITELIST_IMPORT'"
          class="customDate"
          prop="time"
        >
          <el-date-picker
            v-model="value.time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item
          v-if="selectItem.taskType==='VERIFY_DEVICE_PULL_PERSON'"
          class="customDate"
          prop="gudRespTime"
        >
          <el-date-picker
            v-model="value.gudRespTime"
            type="daterange"
            range-separator="~"
            start-placeholder="处理开始日期"
            end-placeholder="处理结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <div class="btn">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onSearch"
          >查询</el-button>
          <el-button
            plain
            @click="resetForm"
          >重置</el-button>
        </div>
      </el-form>
    </template>
    <template v-slot:append>
      <div>
        <el-button
          v-if="selectItem.taskType==='ZQXY_PERSON_PULL'"
          type="primary"
          @click="batchAllot(1)"
        >批量分配班组</el-button>
        <el-button
          v-if="selectItem.taskType==='ZQXY_PERSON_PULL'"
          type="primary"
          @click="batchAllot(2)"
        >批量分配工种</el-button>
      </div>
    </template>
  </HeaderForm>
</template>

<script>
import { personType } from '@/const/index'
export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    selectItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      personType
    }
  },
  methods: {
    onSearch() {
      this.value.pageNumber = 1
      this.$emit('onSearch')
    },
    addNewData() {
      this.$emit('addNewData')
    },
    batchDelete() {
      this.$emit('batchDelete')
    },
    batchAllot(type) {
      this.$emit('batchAllot', type)
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.onSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  width: 130px;
}
::v-deep .customDate .el-form-item__content {
  width: 264px;
}
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 264px;
}
.btn {
  display: inline-block;
  padding-bottom: 10px;
}
</style>
